<script setup lang="ts">
import { computed, useSlots } from 'vue';

const props = withDefaults(
  defineProps<{
    headerDivider?: boolean;
    footerDivider?: boolean;
    /**
     * Stretches the content area to the modal edges (compensates the modal
     * shell padding), so full-height layouts with their own dividers can
     * reach the header divider and the dialog border.
     */
    fullBleedContent?: boolean;
  }>(),
  { headerDivider: false, footerDivider: false, fullBleedContent: false },
);

const slots = useSlots();

const contentClass = computed(() => {
  if (!props.fullBleedContent) {
    return 'w-full p-1';
  }

  return slots.footer ? '-mx-5' : '-mx-5 -mb-5';
});
</script>

<template>
  <div class="flex min-w-0 flex-1 flex-col">
    <slot name="header" />
    <hr v-if="props.headerDivider" class="-mx-5 border-slate-200" />
    <div
      class="flex min-h-0 min-w-0 flex-1 flex-col overflow-auto"
      :class="contentClass"
    >
      <slot name="content" />
    </div>
    <hr v-if="props.footerDivider" class="-mx-5 border-slate-200" />
    <div v-if="$slots.footer" class="shrink-0">
      <slot name="footer" />
    </div>
  </div>
</template>
